import { useTranslation } from '@exam-room/translations';

import { Alert } from '../../../../components';

export default function ExamEventPreviewBanner() {
  const { t } = useTranslation();

  return (
    <Alert
      className='rounded-none py-4 text-start'
      variant='info'
      message={
        <>
          <span className='font-semibold'>{t('examEventPreviewBanner.message.title')} </span>
          {t('examEventPreviewBanner.message.description')}
        </>
      }
    />
  );
}
